import { UserQuestionnaireType } from '@/components/decision-tree';
import { AnswerModel } from '@/components/decision-tree/hooks/useHandleAnswers/types';
import apiClient from '../client/api';

export type PutQuestionnaireAnswerPayload = {
  surveyItemId: string;
  answer: AnswerModel;
  isIntervention?: boolean;
};

async function get(): Promise<UserQuestionnaireType> {
  const res = await apiClient.get('/user-questionnaires/assessment/current');
  return res.data;
}

async function sendAnswer(payload: PutQuestionnaireAnswerPayload): Promise<UserQuestionnaireType> {
  const res = await apiClient.put(
    `/user-questionnaires/assessment/current/survey-item/${payload.surveyItemId}${
      payload.isIntervention ? '/true' : ''
    }`,
    payload.answer
  );
  return res.data;
}

export default { get, sendAnswer };
